import { addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { chain, FindDefaultBillTo, FindDefaultShipTo } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { getBillTos, getShipTos } from "@store/Services/CustomersService"; // Poolcorp Custom Code
import setInitialValues from "@store/Store/Pages/AccountSettings/Handlers/SetInitialValues";

addToEndOfChain(chain, props => {
    const account = getCurrentAccountState(props.getState()).value;

    if (account) {
        props.dispatch(setInitialValues());
    }
});

replaceInChain(chain, FindDefaultBillTo, async props => {
    const billToCollection = await getBillTos({}); // Poolcorp Custom Import
    const billTos = billToCollection.billTos!;

    if (billTos.length === 1) {
        props.defaultBillTo = billTos[0];
    } else {
        const defaultBillTos = billTos.filter(o => o.isDefault);

        if (defaultBillTos.length === 1) {
            props.defaultBillTo = defaultBillTos[0];
        }
    }
});

replaceInChain(chain, FindDefaultShipTo, async props => {
    if (!props.defaultBillTo) {
        return;
    }

    const shipToCollection = await getShipTos({ // Poolcorp Custom Import
        billToId: props.defaultBillTo.id,
        exclude: ["oneTime"],
    });
    const shipTos = shipToCollection.shipTos!;
    if (shipTos.length === 1) {
        props.defaultShipTo = shipTos[0];
    } else {
        const defaultShipTos = shipTos.filter(o => o.isDefault);
        if (defaultShipTos.length === 1) {
            props.defaultShipTo = defaultShipTos[0];
        }
    }
});